import { matchPath, Navigate, useLocation, useSearchParams } from 'react-router-dom'
import * as HomeApi from '@/api/home'
import { UserStore } from '@/global-states'
import { isMobile } from '@/libs/util'
import { rootRouter } from '@/routers/index'

const AuthRouter = (props: { children: JSX.Element }) => {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const code = searchParams.get('code')

  if (token) {
    localStorage.setItem('token', token)
  }

  if (code) {
    if (!UserStore.getToken()) {
      sessionStorage.setItem('redirectUrl', pathname)
    }
    sessionStorage.setItem('code', code)
  }

  // 路径兼容
  const promoterMatch = matchPath('/p/:promoterCode', pathname)
  const inviteMatch = matchPath('/i/:inviteCode', pathname)
  if (promoterMatch?.params?.promoterCode) {
    localStorage.setItem('promoterCode', promoterMatch.params.promoterCode)
  }
  if (inviteMatch?.params?.inviteCode) {
    sessionStorage.setItem('code', inviteMatch.params.inviteCode)
  }

  const promoterCode = searchParams.get('promoterCode') || searchParams.get('referral_code')
  if (promoterCode) {
    localStorage.setItem('promoterCode', promoterCode)
  }

  const di = searchParams.get('di')
  if (di) {
    localStorage.setItem('di', di)
  }

  const keywords = searchParams.get('ky') || searchParams.get('_kw')
  if (keywords) {
    sessionStorage.setItem('keywords', keywords)
  }

  const bd_vid = searchParams.get('bd_vid')
  if (bd_vid) {
    sessionStorage.setItem('bd_vid', bd_vid.includes('https') ? bd_vid : location.href)
    window.history.replaceState({}, '', `${location.origin}${location.pathname}`)
  }

  const utm = searchParams.get('utm')
  if (utm) {
    sessionStorage.setItem('utm', utm)
    window.history.replaceState({}, '', `${location.origin}${location.pathname}`)
  }

  const msclkid = searchParams.get('msclkid')
  if (msclkid) {
    sessionStorage.setItem('msclkid', msclkid.includes('https') ? msclkid : location.href)
    window.history.replaceState({}, '', `${location.origin}${location.pathname}`)
  }

  if (!sessionStorage.getItem('web') && isMobile()) {
    if (pathname.includes('mobile')) {
      return props.children
    } else {
      return <Navigate to="/mobile" replace />
    }
  }

  checkVersion()

  const route = searchRoute(pathname, rootRouter)
  // 判断当前路由是否需要访问权限(不需要权限直接放行)
  if (!route.meta?.requiresAuth) return props.children

  // 判断是否有Token，无token跳转登陆
  if (!UserStore.getToken()) {
    return <Navigate to="/login" replace />
  }

  // 当前账号有权限返回 Router，正常访问页面
  return props.children
}

export const searchRoute = (path: string, routes: any) => {
  let result = {}
  for (const item of routes) {
    if (item.path === path) return item
    if (item.children) {
      const res = searchRoute(path, item.children)
      if (Object.keys(res).length) result = res
    }
  }
  return result
}

// 校验系统最新版本
export const checkVersion = async () => {
  const currentVersion: any = localStorage.getItem('version_ui')
  const res = await HomeApi.getSystemInfo()
  UserStore.systemInfo = res

  const version = res?.web_ui_version
  if (version) {
    localStorage.setItem('version_ui', `${res.web_ui_version}`)
  }
  if (currentVersion && version && currentVersion !== res?.web_ui_version) {
    location.reload()
  }
}

export default AuthRouter
